import React, { FC, useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'
import EditModal from '../../../components/setting/record/EditModal'
import { fetchMemberWeeklyTrackTime } from '../../../../states/containers/setting/memberWeeklyTrackTimeSlice'
import Tips from '../../../components/common/Tips'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface membersModal {
  id: number
  name: string
  kana: string | null
  email: string
  code: string | null
  contract: string | null
  profile_image: string | null
  change_authority: boolean
  weekly_track_times: weekly_track_time[]
}

interface weekly_track_time {
  week_number: number
  track_start_time: string | null
  track_stop_time: string | null
}
interface unCreateMembersModal {
  id: number
  name: string | null
  kana: string | null
  email: string | null
  code: string | null
  contract: string | null
  profile_image: string | null
}

interface EditModalState {
  display: boolean
  type: string
  editData: weekly_track_time[] | null
  targetMemberData: membersModal[] | null
  selectableMemberData: unCreateMembersModal[] | null
}

const Index: FC = () => {
  const dispatch = useDispatch()

  const {
    commonPart,
    memberWeeklyTrackTime,
    login,
  } = useSelector((state: RootState) => state)

  const [memberDetail, setMemberDetail] = useState<membersModal>()
  const [exhibitWeeklyTrackTime, setExhibitWeeklyTrackTime] = useState<weekly_track_time[]>()
  const [member, setMember] = useState<membersModal[]>()
  const [editModalState, setEditModalState] = useState<EditModalState>({
    display: false,
    type: "",
    editData: null,
    targetMemberData: null,
    selectableMemberData: null,
  })

  useEffect(() => {
    if (!login.accessToken) return
    if (!commonPart.company?.id) return
    dispatch(
      fetchMemberWeeklyTrackTime({ only_oneself: true }),
    )
  }, [login.accessToken, commonPart.company])

  useEffect(() => {
    if (!memberWeeklyTrackTime.member_list) return
    const tmp = memberWeeklyTrackTime.member_list.find((_, i) => i === 0)
    setMemberDetail(tmp)
    setMember(memberWeeklyTrackTime.member_list)
  }, [memberWeeklyTrackTime.member_list])

  useEffect(() => {
    const tmp = memberDetail?.weekly_track_times
    setExhibitWeeklyTrackTime(tmp)
  }, [memberDetail?.weekly_track_times])

  const openEditModal = () => {
    setEditModalState({
      display: true,
      type: "updateOneself",
      editData: memberDetail ? memberDetail.weekly_track_times : null,
      targetMemberData: member || null,
      selectableMemberData: null,
    })
  }

  const closeEditModal = () => {
    setEditModalState({
      display: false,
      type: "",
      editData: null,
      targetMemberData: null,
      selectableMemberData: null,
    })
  }

  const displayTime = (value: {week_number: number, track_start_time: string | null, track_stop_time: string | null}) => {
    if ((value.track_start_time === value.track_stop_time) && (value.track_start_time !== null && value.track_stop_time !== null)) {
      return (
        <Tips
          description="計測しない"
          className=""
          icon={false}
        >
          <div style={{ color: "#FF0000", fontSize: "22px" }}>
            <FontAwesomeIcon icon={['fas', 'times']} />
          </div>
        </Tips>
      )
    }
    if ((value.track_start_time === null) && (value.track_stop_time === null)) {
      return (
        <Tips
          description="終日計測する"
          className=""
          icon={false}
        >
          <div style={{ color: "#0f9655", fontSize: "22px" }}>
            <FontAwesomeIcon icon={['fas', 'play-circle']} />
          </div>
        </Tips>
      )
    }
    return (
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "2px",
        }}
      >
        <Tips
          description="計測制限あり"
          className=""
          icon={false}
        >
          <div style={{ color: "#777777", fontSize: "16px" }}>
            <FontAwesomeIcon icon={['far', 'clock']} />
          </div>
        </Tips>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "2px",
          }}
        >
          <div>
            {value.track_start_time ? value.track_start_time.substring(0, 5) : ""}
          </div>
          <div>
            ~
          </div>
          <div>
            {value.track_stop_time ? value.track_stop_time.substring(0, 5) : ""}
          </div>
        </div>
      </div>
    )
  }

  const legend = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "8px",
        padding: "8px 16px",
        border: "solid 1px #CCCCCC",
        backgroundColor: "#FAFAFA",
        marginBottom: "8px",
      }}
    >
      <div
        style={{
          fontWeight: "bold",
          color: "#666666",
        }}
      >
        凡例
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "right",
          gap: "8px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "2px",
            fontSize: "11px",
          }}
        >
          <div style={{ color: "#0f9655" }}>
            <FontAwesomeIcon icon={['fas', 'play-circle']} />
          </div>
          <div>
            :
          </div>
          終日計測する
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "2px",
            fontSize: "11px",
          }}
        >
          <div style={{ color: "#FF0000" }}>
            <FontAwesomeIcon icon={['fas', 'times']} />
          </div>
          <div>
            :
          </div>
          計測しない
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "2px",
            fontSize: "11px",
          }}
        >
          <div style={{ color: "#777777" }}>
            <FontAwesomeIcon icon={['far', 'clock']} />
          </div>
          <div>
            :
          </div>
          計測制限あり
        </div>
      </div>
    </div>
  )

  return (
    <section className="setting_page">
      <Helmet>
        <title>Qasee - 設定 - 個人設定 - あなたの計測時間設定</title>
      </Helmet>
      <section className="breadcrumb">
        設定
        &nbsp;&gt;&nbsp;
        個人設定
        &nbsp;&gt;&nbsp;
        あなたの計測時間設定
        &nbsp;
      </section>
      <section className="page_header">
        <h1>あなたの計測時間設定</h1>
      </section>
      <section className="page_description">
        <p>
          Qaseeで計測する時間を設定することができます。
        </p>
        <p>
          指定した時間内のみ計測を行います。
        </p>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-detail">
            <div className="header_area measurement">
              <div className="title">あなたの計測時間</div>
              {
                memberDetail?.change_authority ? (
                  <button
                    type="button"
                    className="edit_button"
                    onClick={openEditModal}
                  >
                    計測時間設定を編集
                  </button>
                ) : (
                  <Tips
                    description="権限がありません"
                    className=""
                    icon={false}
                  >
                    <button
                      type="button"
                      className="edit_button checked"
                      onClick={openEditModal}
                    >
                      計測時間設定を編集
                    </button>
                  </Tips>
                )
              }
            </div>
            {legend}
            <table className="company_track_table">
              <thead>
                <tr>
                  <th style={{ color: "#FF0000" }}>日曜日</th>
                  <th>月曜日</th>
                  <th>火曜日</th>
                  <th>水曜日</th>
                  <th>木曜日</th>
                  <th>金曜日</th>
                  <th style={{ color: "#317AB7" }}>土曜日</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {
                    exhibitWeeklyTrackTime && exhibitWeeklyTrackTime.map((v) => (
                      <td key={v.week_number}>
                        {displayTime(v)}
                      </td>
                    ))
                  }
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <EditModal
          editModalState={editModalState}
          closeCallback={closeEditModal}
        />
      </section>
    </section>
  )
}

export default Index
